export default class {

    constructor() {
        this.init();
    }

    init() {
        this.nodeListForEach();
        this.arrayForEach();
        this.createEvents();
        this.createCustomEvents();
        this.nodeClosest();
        this.childNodeRemove();
        this.objectAssign();
    }

    nodeListForEach() {
        /**
         * NodeList.prototype.forEach() polyfill
         * https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach#Polyfill
         */
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (let i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }

    arrayForEach() {
        /**
         * Array.prototype.forEach() polyfill
         * @author Chris Ferdinandi
         * @license MIT
         */
        if (!Array.prototype.forEach) {
            Array.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (let i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }

    createCustomEvents() {
        if ( typeof window.CustomEvent === "function" ) return false;// If not IE

        function CustomEvent ( event, params ) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            let evt = document.createEvent( 'CustomEvent' );
            evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    }

    createEvents() {
        if ( typeof window.Event === "function" ) return false;// If not IE

        function Event ( event, params ) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            let evt = document.createEvent( 'Event' );
            evt.initEvent( event, params.bubbles, params.cancelable, params.detail );
            return evt;
        }

        Event.prototype = window.Event.prototype;

        window.Event = Event;
    }

    nodeClosest() {
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
            Element.prototype.closest = function(s) {
                let el = this;

                do {
                    if (el.matches(s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
        }
    }

    childNodeRemove() {
        (function (arr) {
            arr.forEach(function (item) {
                if (item.hasOwnProperty('remove')) {
                    return;
                }
                Object.defineProperty(item, 'remove', {
                    configurable: true,
                    enumerable: true,
                    writable: true,
                    value: function remove() {
                        this.parentNode.removeChild(this);
                    }
                });
            });
        })([Element.prototype, CharacterData.prototype, DocumentType.prototype]);
    }

    objectAssign() {
        if (typeof Object.assign != 'function') {
            Object.assign = function (target, varArgs) { // .length of function is 2
                'use strict';
                if (target == null) { // TypeError if undefined or null
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                var to = Object(target);

                for (var index = 1; index < arguments.length; index++) {
                    var nextSource = arguments[index];

                    if (nextSource != null) { // Skip over if undefined or null
                        for (var nextKey in nextSource) {
                            // Avoid bugs when hasOwnProperty is shadowed
                            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
                return to;
            };
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/common/Polyfills.js